module.exports = __webpack_public_path__ + "img/foreign.9dd4203f.svg";